import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SkillPracticeTaskStatus } from '../../../models/skill-learning.model';

type SkillPracticeTaskStatusInput = SkillPracticeTaskStatus | null;

const PRACTICE_STATUS_LABELS: { [key: string]: string } = {
  'CREATED': 'SKILL_LEARNING_PRACTICE_STATUS_CREATED',
  'IN_WORK': 'SKILL_LEARNING_PRACTICE_STATUS_IN_WORK',
  'COMPLETED': 'SKILL_LEARNING_PRACTICE_STATUS_COMPLETED',
  'CANCELLED': 'SKILL_LEARNING_PRACTICE_STATUS_CANCELLED',
};

@Component({
  selector: 'app-practice-task-status',
  templateUrl: './practice-task-status.component.html',
  styleUrls: ['./practice-task-status.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PracticeTaskStatusComponent {
  @Input() taskStatus: SkillPracticeTaskStatusInput = null;
  @Input() curatorName: string | null = null;
  @Input() curatorPhone: string | null = null;
  @Input() planfixTaskId: number | null = null;
  @Input() planfixTaskUrl: string | null = null;

  get hasCurator(): boolean {
    return !!this.curatorName || !!this.curatorPhone;
  }

  get hasPlanfixTaskLink(): boolean {
    return !!this.planfixTaskUrl;
  }

  get statusLabel(): string {
    if (!this.taskStatus) {
      return '';
    }
    return PRACTICE_STATUS_LABELS[this.taskStatus] || '';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/practice-level/practice-task-status.component.ts